import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/style/animation.main.less'
import '@/style/style.main.less'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
